import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import V2UserDetail from '../admin/V2UserDetail';
import V2AdminPageHeading from '../components/V2AdminPageHeading';

const V2User: React.FC = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  return (
    <>
      <V2AdminPageHeading
        title={t('admin_user_title', { id })}
        description={t('admin_user_description')}
        backLink={{
          to: '/users',
          label: t('admin_user_back'),
        }}
      />
      <div className="v2-admin-user-detail-wrap">
        <V2UserDetail />
      </div>
    </>
  );
};

export default V2User;
